exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.slow-query-list td.url {\n  max-width: 30rem; }\n", ""]);

// exports
